module.exports = __webpack_public_path__ + "static/zedindustriesgreen-logo-hover-5c4092d0dfa15b072f5a614b588914e5.png";